export const DANGER_COLORS: Record<number, string> = {
  3: '#E3B23F',
  1: '#CC3333',
  4: '#006666',
  5: '#006666',
  2: '#CC6633',
};
